__turbopack_context__.v({
  "buyerProtection": "styles-module__JyCIgG__buyerProtection",
  "depopLogo": "styles-module__JyCIgG__depopLogo",
  "header": "styles-module__JyCIgG__header",
  "title": "styles-module__JyCIgG__title",
});
